<script setup>
import tippy from "tippy.js";
import {ref, onMounted} from "vue";

const props = defineProps(['tooltip']);
const icon = ref(null);
onMounted(() => {
  tippy(icon.value, {
    content: props.tooltip,
    trigger: 'click',
  });
})
</script>

<template>
  <span ref="icon" class="info-icon">
    <svg class="icon icon-info"><use xlink:href="#icon-info"></use></svg>
  </span>
</template>